export const CHANGE_UNITS = 'MEASURE/CHANGE_UNITS';
export const TOGGLE_MEASURE_ACTIVE = 'MEASURE/TOGGLE_MEASURE_ACTIVE';
export const UPDATE_MEASUREMENTS = 'MEASURE/UPDATE_MEASUREMENTS';
